<template lang="html">
  <div class="VideoSnippet">
    <router-link :to="'/clip/' + chunks[0].id">
      <img :src="'https://i.ytimg.com/vi/' + video.key + '/sddefault.jpg'" alt="">
    </router-link>
    <div class="chunks">
      <p>{{video.title}}</p>
      <ul>
        <router-link v-for="chunk in threeChunks" :key="chunk.id" :to="'/clip/' + chunk.id" :title="chunk.title">
          <li v-if="chunk.title.length > 50">
            {{chunk.title.slice(0,50) + "..."}}
          </li>
          <li v-else>
            {{chunk.title}}
          </li>
        </router-link>
        <li class="more-chunks" v-if="moreChunksCout > 0">
          + <router-link :to="'/clip/' + chunks[3].id">
            {{moreChunksCout}} more
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'VideoSnippet',
  props: ['video'],
  computed: {
    ...mapGetters([
      'chunksFromThisVideo',
    ]),
    chunks() {
      return this.chunksFromThisVideo(this.video.id)
    },
    threeChunks() {
      return this.chunks.slice(0,3)
    },
    moreChunksCout() {
      let total = this.chunks.length
      return total-3
    },
    title() {
      let title = ""
      if (this.chunk.end > this.chunk.start) {
        title = this.stringTime(this.chunk.end - this.chunk.start) + " from " + this.minSeconds(this.chunk.start)
      } else {
        title = "From " + this.minSeconds(this.chunk.start)
      }
      return title
    }
  },
  methods: {
    minSeconds(seconds) {
      let reminder = seconds%60
      if (reminder < 10) {
        reminder = "0" + reminder
      }
      return Math.floor(seconds/60) + ":" + reminder
    },
    stringTime(seconds) {
      let string = ""
      if (seconds <= 60) {
        string = seconds + "s"
      } else {
        string = Math.floor(seconds/60) + "m " + seconds%60 + "s"
      }
      return string
    }
  }
}
</script>

<style lang="css" scoped>
.VideoSnippet {
  width: 32%;
  background-color: rgb(30, 38, 51);
  margin-bottom: 2rem;
  border-radius: 9px;
  overflow: hidden;
  height: fit-content;
}
img {
  width: 100%;
  height: 13rem;
  object-fit: cover;
}
ul {
  list-style: none;
  padding: 0;
  margin-bottom: 0;
}
p {
  margin-bottom: 1rem;
  line-height: 130%;
}
li {
  font-family: 'Roboto', Helvetica, Arial, sans-serif;
  padding: 0.5rem 1rem;
  border-radius: 7px;
  background-color: rgb(97, 132, 148);
  margin: 0 0 1rem;
}
li:hover {
  background-color: rgb(118, 151, 167);
}
a {
  color: #000;
}
a:hover {
  color: rgb(127, 2, 2);
}
.chunks {
  padding: 0.7rem 1.5rem 0;
}
.more-chunks {
  background-color: unset;
  text-align: center;
  margin-bottom: 1rem;
}
.more-chunks:hover {
  background-color: unset;
}
.more-chunks, .more-chunks a {
  color: rgb(186, 181, 163);
}
.more-chunks a:hover {
  color: rgb(194, 42, 42);
}
</style>
